<div class="mainmenu">
    <nz-layout class="layout">
        <nz-sider nzCollapsible nzBreakpoint="lg" [nzCollapsedWidth]="0" [(nzCollapsed)]="isMenuHidden">
            <ul nz-menu [nzMode]="'horizontal'" nzTheme="dark" class="hidden-categories-xs">
                <ng-container *ngFor="let item of (categories)">
                    <li nz-menu-item [routerLink]="['/category', item.slug]" [ngClass]="item.slug">
                        {{item.title}}</li>

                </ng-container>



                <!-- <li nz-menu-item [routerLink]="['/category']">Business</li>
        <li nz-menu-item [routerLink]="['/category']">News</li>
        <li nz-menu-item [routerLink]="['/category']">Sport</li>
        <li nz-menu-item [routerLink]="['/category']">Religion</li>
        <li nz-menu-item [routerLink]="['/category']">Creative</li>
        <li nz-menu-item [routerLink]="['/category']">Opinion</li>
        <li nz-menu-item [routerLink]="['/category']">Tech and science</li>
        <li nz-menu-item [routerLink]="['/category']">Viral</li>
        <li nz-menu-item [routerLink]="['/category']">Entertainment</li> -->

                <!-- <li nz-menu-item class="is-search-icon">
            <a (click)="searchToggle()">
                <i nz-icon nzType="search" theme="outline"></i>
            </a>
            <nz-drawer [nzWidth]="380" nzTitle="Search" [nzVisible]="searchVisible" nzPlacement="right" (nzOnClose)="searchToggle()">
                <app-search></app-search>
            </nz-drawer>
        </li> -->
                <li class="megamenu-list  start-hover" id="mega-menu-header" (mouseenter)="showMoreMegaMenu()"
                    (mouseleave)="hideMegaMenu()">
                    <a class="megamenu-link">{{'More' | translate}} <i nz-icon nzType="down" nzTheme="outline"></i></a>
                    <div class="mega-body-sec" id="mega-menu-section">
                        <div class="megamenu-body">
                            <div class="sub-catagories-sec">
                                <ng-container *ngFor="let item of (categories)">
                                    <div class="sub-catagories-list" [ngClass]="item.slug">
                                        <h2>{{item.title}}</h2>
                                        <ul>
                                            <li (click)="hideMegaMenu()"
                                                *ngFor="let topic of (categoryListData[item.uid].child | async )"
                                                nz-menu-item [routerLink]="['/category', item.slug]"
                                                [queryParams]="{topic:topic.slug}" class="mega-menu-list-item">
                                                {{topic.title}}
                                            </li>
                                        </ul>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="megamenu-list city-dropdown start-hover" id="mega-menu-header" (mouseenter)="showCityMegaMenu()"
                    (mouseleave)="hideMegaMenuCity()">
                    <a class="megamenu-link">{{'city' | translate}} <i nz-icon nzType="down" nzTheme="outline"></i></a>
                    <div class="mega-body-sec" id="mega-menu-section-city">
                        <div class="megamenu-body">
                            <div class="sub-catagories-sec">
                                <div class="sub-catagories-list">
                                    <h3>{{'city' | translate}}</h3>
                                    <ng-container *ngFor="let item of (categories)">
                                        <ul *ngIf="(item?.title) == 'Ciudad' || (item?.title) == 'City' || (item?.title) == 'Ville'">
                                            <li (click)="hideMegaMenuCity()"
                                                *ngFor="let topic of countryListArray"
                                                nz-menu-item [routerLink]="['/category', item.slug]"
                                                [queryParams]="{topic:topic.slug}" class="mega-menu-list-item">
                                                {{topic.title}}
                                            </li>
                                        </ul>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>


            </ul>

            <ul nz-menu [nzMode]="'inline'" class="hidden-on-lg mobile-mega-menu">
                <li>
                    <h2 class="menu-title">{{'menu' | translate}}</h2>
                </li>
                <li routerLink="/" nz-menu-item class="border-bottom" (click)="hideMenu()">Home</li>
                <li routerLink="/today" nz-menu-item class="border-bottom" (click)="hideMenu()">Today's Stories</li>
                <ng-container *ngFor="let item of (categories)">
                    <li class="border-bottom" nz-menu-item [routerLink]="['/category', item.slug]" [ngClass]="item.slug"
                        (click)="hideMenu()">
                        {{item.title}}</li>

                </ng-container>

                <li nz-submenu nzTitle="{{'More' | translate}}" class="xs-menu-item">
                    <ng-container *ngFor="let item of (categories)">
                        <div [ngClass]="item.slug">
                            <h2 class="category-title-xs">{{item.title}}</h2>
                            <ul>
                                <li *ngFor="let topic of (categoryListData[item.uid].child | async )" nz-menu-item
                                    [routerLink]="['/category', item.slug]" [queryParams]="{topic:topic.slug}"
                                    class="xs-menu-sub-category" (click)="hideMenu()">
                                    {{topic.title}}
                                </li>
                            </ul>
                        </div>
                    </ng-container>
                </li>
                <li nz-submenu nzTitle="{{'city' | translate}}" class="xs-menu-item xs-city-menu" (click)="showMoreMegaMenu()">
                    <ng-container *ngFor="let item of (categories)">
                        <ul *ngIf="(item?.title) == 'Ciudad' || (item?.title) == 'City' || (item?.title) == 'Ville'">
                            <li (click)="hideMenu()"
                                *ngFor="let topic of countryListArray"
                                nz-menu-item [routerLink]="['/category', item.slug]"
                                [queryParams]="{topic:topic.slug}" class="mega-menu-list-item">
                                {{topic.title}}
                            </li>
                        </ul>
                    </ng-container>
                </li>


                <li class="h-auto line-height-normal" nz-menu-item *ngIf="!isLoggedInUser">
                    <a class="is-login-link" (click)="routeLogin()">
                        {{'login' | translate }}
                        <img src="assets/images/sign-up.png" alt="sign up icon">
                    </a>
                </li>
                <li nz-menu-item *ngIf="!isLoggedInUser" class="h-auto">
                    <button (click)="routeSignup()" nz-button nzType="primary" class="is-sign-up-btn">
                        {{'signUp' | translate }}
                        <img src="assets/images/sign-up.png" alt="sign up icon">
                    </button>
                </li>
            </ul>
        </nz-sider>
    </nz-layout>
</div>
